import { render, staticRenderFns } from "./DummyHeader.vue?vue&type=template&id=68a3dc3c&scoped=true"
import script from "./DummyHeader.vue?vue&type=script&lang=js"
export * from "./DummyHeader.vue?vue&type=script&lang=js"
import style0 from "./DummyHeader.vue?vue&type=style&index=0&id=68a3dc3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a3dc3c",
  null
  
)

export default component.exports